/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useMutation } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { mutationKeys } from "./queryKeys";

export const useClientLogin = () => {
  return useMutation({
    mutationKey: mutationKeys.clientLogin,
    mutationFn: (data) => fetcher({ method: "POST", url: "/public/clients/login/", data }),
  });
};
